exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".danger-color{color:#e65454}.warning-color{color:#f0ad4e}.success-color{color:#5cb85c}.default-color{color:#e6e6e6}.white-color{color:#fff}.grey-color{color:#666}.grey-dark-color{color:#333}.grey-light-color{color:#999}.danger-bg{background-color:#e65454}.warning-bg{background-color:#f0ad4e}.success-bg{background-color:#5cb85c}.default-bg{background-color:#e6e6e6}.orange-bg{background-color:#f29354}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/common/scss/common/article.scss
// module id = 593
// module chunks = 2